/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Role {
    CONTRIBUTOR = 'CONTRIBUTOR',
    CREATOR = 'CREATOR',
    CLIENT = 'CLIENT',
    ADMIN = 'ADMIN',
    SUPERADMIN = 'SUPERADMIN',
}
